module.exports = __webpack_public_path__ + "img/exporting.43f53c76.svg";